/**
 *
 * http配置
 *
 */
import axios from 'axios';
import router from './router';
import store from '../store';
import { message } from '@/resetMessage';//重写防止重复弹出
import errorCode from '@/const/errorCode';
import { Toast } from 'vant';
import { encrypt } from "../util/util";
// 超时时间
axios.defaults.timeout = 1000000;
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
// 重新请求标志位，避免无限循环请求
axios.defaults.isRetryRequest = false;

axios.defaults.validateStatus = function validateStatus(status) {
  return /^(2|3)\d{2}$/.test(status) || status === 401;
};

// 刷新token的状态 0-未刷新 1-正在刷新 2-刷新失败
let refreshingTokenStatus = 0;
// 设置请求默认前缀
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
Toast.allowMultiple();
let toastLoading = null
let toastMsg = null
// HTTPrequest拦截
axios.interceptors.request.use((config) => {
  toastLoading = Toast.loading({
    duration: 0, // 持续展示 toast
    forbidClick: true,
    message: 'Loading ...',
  });
  const token = localStorage.getItem('token')
  if (config.data) {
    config.data.token = token
    let AESEncryptData = encrypt(JSON.stringify(config.data),'');
    config.data = {
      req: AESEncryptData
    }
  }
  if (config.params) {
    // config.params.token = token
    let AESEncryptData = encrypt(JSON.stringify(config.params), '');
    config.params = {
      req: AESEncryptData
    }
  }
  return config;
}, error => {
  return Promise.reject(error)
});


// HTTPresponse拦截
axios.interceptors.response.use((res) => {
  const { msg, code, data } = res.data;
  const { status } = res;
  toastLoading.clear()
  if(status === 200) {
    if(code === 0) {
      return res.data.data;
    } else if (code === -1) { // token无效
      toastMsg = Toast('登录信息过期，请重新登录')
      localStorage.removeItem('token')
      localStorage.removeItem('empInfo')
      localStorage.removeItem('baseDataId')
      localStorage.removeItem('baseDataName')
      router.push({
        path: '/mobile/login'
      });
    } else {
      toastMsg = Toast(msg)
      return Promise.reject(msg);
    }
  } else {
    toastMsg = Toast(msg)
    return Promise.reject(msg);
  }
  setTimeout(() => {
    toastMsg.clear()
  }, 5000)
}, (error) => {
  toastLoading.clear()
  return Promise.reject(error);
});
export default axios;
